module.exports = (__webpack_require__(1))(65);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/AssetstoreModel.js from dll-reference girder_lib
// module id = 5
// module chunks = 0